// Appels HTTP typés vers /api/projects/*.

import { api } from "./client";
import type {
  ProjectCreate,
  ProjectPublic,
  ProjectUpdate,
  UUID,
} from "./types";

export type ListProjectsParams = {
  client_id?: UUID;
  limit?: number;
  offset?: number;
};

function buildQuery(params: Record<string, unknown>): string {
  const parts: string[] = [];
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null || value === "") continue;
    parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
  }
  return parts.length ? `?${parts.join("&")}` : "";
}

export const projectsApi = {
  list: (params: ListProjectsParams = {}) =>
    api.get<ProjectPublic[]>(`/api/projects${buildQuery(params)}`),

  get: (id: UUID) => api.get<ProjectPublic>(`/api/projects/${id}`),

  create: (payload: ProjectCreate) =>
    api.post<ProjectPublic>("/api/projects", payload),

  update: (id: UUID, payload: ProjectUpdate) =>
    api.patch<ProjectPublic>(`/api/projects/${id}`, payload),

  delete: (id: UUID) => api.delete<void>(`/api/projects/${id}`),
};
